// import axios from "axios";
// import React, { useState, useEffect } from "react";
// import { FaPlusCircle, FaTrash, FaBoxOpen, FaTimes, FaChevronLeft, FaChevronRight, FaWhatsapp, } from "react-icons/fa";
// import { Pencil, Trash } from 'lucide-react';
// import './productMaster.css'
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";

// const API_BASE = "https://cloudapi.emedhatechnologies.com/pages/api/api";

// const ProductMaster = () => {
//   const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState({ category: "", subcategory: "" });
//   const [variants, setVariants] = useState([{ code: "", size: "", qty: "", image: null }]);
//   const [products, setProducts] = useState([]);
//   const [editMode, setEditMode] = useState(false);
//   const [editProductId, setEditProductId] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [page, setPage] = useState(1);
//   const perPage = 40;
//   const [categories, setCategories] = useState([]);
//   const [subcategories, setSubcategories] = useState([]);


//   // ⭐ ADD THESE STATES ALONG WITH OTHER STATES
//   const [filterCode, setFilterCode] = useState("");
//   const [zoomImage, setZoomImage] = useState(null);

//   useEffect(() => {
//     const stored = sessionStorage.getItem("userData");
//     if (stored) setUser(JSON.parse(stored));
//   }, []);


//   const userId = user
//     ? user.type === "employee"
//       ? user.parent_company_id
//       : user.id
//     : null;
//   console.log("userId", userId)


//   const currentUserId = user ? user.id : null;

//   console.log("currentUserId", currentUserId)

//   const fetchProducts = () => {
//     if (!userId) return;
//     fetch(`${API_BASE}/products/${userId}`)
//       .then((res) => res.json())
//       .then(setProducts)
//       .catch((err) => console.error("Failed to fetch products:", err));
//   };

//   useEffect(() => {
//     fetchProducts();
//   }, [userId]);

//   const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

//   const handleVariantChange = (index, e) => {
//     const { name, value, files } = e.target;
//     const updated = [...variants];
//     updated[index][name] = files ? files[0] : value;
//     setVariants(updated);
//   };

//   const addVariant = () =>
//     setVariants([...variants, { code: "", size: "", qty: "", image: null }]);
//   const removeVariant = (i) => setVariants(variants.filter((_, idx) => idx !== i));

//   const resetForm = () => {
//     setFormData({ category: "", subcategory: "" });
//     setVariants([{ code: "", size: "", qty: "", image: null }]);
//     setEditMode(false);
//     setEditProductId(null);
//     setShowModal(false);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!userId) return alert("Please log in");

//     try {
//       let productId = editProductId;

//       if (!editMode) {
//         const productRes = await fetch(`${API_BASE}/products`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ ...formData, user_id: userId, current_user_id: currentUserId }),
//         });
//         const data = await productRes.json();
//         productId = data.product_id;
//       } else {
//         await fetch(`${API_BASE}/products/${productId}`, {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ ...formData, current_user_id: currentUserId }),
//         });
//       }

//       for (const variant of variants) {
//         const form = new FormData();
//         form.append("code", variant.code);
//         form.append("size", variant.size);
//         form.append("qty", variant.qty);
//         form.append("current_user_id", currentUserId);
//         if (variant.image) form.append("image", variant.image);

//         if (variant.id) {
//           await fetch(`${API_BASE}/variants/${variant.id}`, {
//             method: "PUT",
//             body: form,
//           });
//         } else {
//           await fetch(`${API_BASE}/products/${productId}/variants`, {
//             method: "POST",
//             body: form,

//           });
//         }
//       }

//       alert(editMode ? "✅ Product updated!" : "✅ Product added!");
//       resetForm();
//       fetchProducts();
//     } catch (err) {
//       console.error(err);
//       alert("❌ Error saving product");
//     }
//   };

//   const handleEditProduct = async (product) => {
//     setEditMode(true);
//     setEditProductId(product.id);
//     setFormData({
//       category: product.category,
//       subcategory: "",
//     });
//     await fetchSubcategories(product.category);
//     setFormData({
//       category: product.category,
//       subcategory: product.subcategory,
//     });
//     setVariants(
//       product.variants.map((v) => ({
//         id: v.id,
//         code: v.code || "",
//         size: v.size || "",
//         qty: v.qty || "",
//         image: null,
//       }))
//     );
//     setShowModal(true);
//   };

//   useEffect(() => {
//     fetchProducts();
//     fetchCategories();
//   }, [userId]);


//   const fetchCategories = async () => {
//     if (!userId) return;
//     const res = await axios.get(`${API_BASE}/categories?userId=${userId}`);
//     setCategories(res.data);
//   };

//   const fetchSubcategories = async (categoryName) => {
//     if (!categoryName) {
//       setSubcategories([]);
//       return;
//     }
//     const res = await axios.get(
//       `${API_BASE}/subcategories/by/name?categoryName=${encodeURIComponent(
//         categoryName
//       )}&userId=${userId}`
//     );
//     setSubcategories(res.data);

//   };

//   const [showBlockedOnly, setShowBlockedOnly] = useState(false);

//   const filteredProducts = products
//     .map((product) => {
//       let variantsToShow = product.variants;

//       // Only apply blocked filter if user is Abhijit and showBlockedOnly is true
//       if (showBlockedOnly && user?.email === "abhijit@spelux.in") {
//         variantsToShow = variantsToShow.filter((v) =>
//           v.code?.toLowerCase().includes("blk")
//         );
//       } else if (filterCode) {
//         const search = filterCode.toLowerCase();
//         variantsToShow = variantsToShow.filter((v) =>
//           product.category?.toLowerCase().includes(search) ||
//           product.subcategory?.toLowerCase().includes(search) ||
//           v.code?.toLowerCase().includes(search) ||
//           v.size?.toLowerCase().includes(search)
//         );
//       }

//       if (variantsToShow.length === 0) return null; // skip products with no variants
//       return { ...product, variants: variantsToShow };
//     })
//     .filter(Boolean); // remove nulls


//   // Filter products based on user
//   const visibleProducts = products.filter((product) => {
//     // If logged-in user is Abhijit, show all products
//     if (user?.email === "abhijit@spelux.in") return true;
//     return product.user_id === currentUserId;
//   });

//   const handleShowBlockedData = () => {
//     setShowBlockedOnly(true); // show only blocked variants
//     setPage(1); // reset to first page
//   };

//   const handleSearchChange = (e) => {
//     setFilterCode(e.target.value);
//     setShowBlockedOnly(false); // exit blocked-only mode when typing
//   };

//   const flattenedVariants = filteredProducts
//     .map((p) =>
//       p.variants.map((v) => ({
//         ...v,
//         category: p.category,
//         subcategory: p.subcategory,
//         productId: p.id,
//       }))
//     )
//     .flat();
//   const totalPages = Math.ceil(flattenedVariants.length / perPage);
//   const paginated = flattenedVariants.slice(
//     (page - 1) * perPage,
//     page * perPage
//   );

//   // 1️⃣ Add this function inside your component
//   const handleExportExcel = () => {
//     if (!filteredProducts || filteredProducts.length === 0) return alert("No data to export");

//     // Prepare the header row
//     const headers = ["S.No", "Category", "Subcategory", "Code", "Size", "Qty", "Image"];

//     // Prepare the rows
//     const rows = filteredProducts
//       .map((p, pIndex) =>
//         p.variants.map((v, vIndex) => [
//           pIndex * perPage + vIndex + 1,
//           p.category,
//           p.subcategory,
//           v.code,
//           v.size,
//           v.qty,
//           v.image || ""
//         ])
//       )
//       .flat();

//     // Combine header and rows
//     const csvContent = [
//       headers.join(","),          // header row
//       ...rows.map(r => r.join(",")) // data rows
//     ].join("\n");

//     // Create a downloadable link
//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.setAttribute("download", "products.csv"); // file name
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   const handleShareWhatsApp = async (product, variant) => {
//     if (!product || !variant) return;
//     const userData = JSON.parse(sessionStorage.getItem("userData"));
//     const email = userData?.email;

//     // 1️⃣ Save share log to DB https://cloudapi.emedhatechnologies.com/pages/api
//     try {
//       await fetch("https://cloudapi.emedhatechnologies.com/pages/api/api/share-log", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           email: email,
//           variant_id: variant.id,
//           variant_code: variant.code,
//         }),
//       });
//     } catch (error) {
//       console.error("Share log failed", error);
//     }
//     // 2️⃣ WhatsApp share
//     const text = `
//                 Category: ${variant.category}
//                 Subcategory: ${variant.subcategory}
//                 Code: ${variant.code}
//                 Size: ${variant.size}
//                 Qty: ${variant.qty}
//                 Image: ${variant.image || "—"}
//                 `;
//     const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
//     window.open(url, "_blank");
//   };

//   const handleExportPDF = () => {
//     if (!filteredProducts || filteredProducts.length === 0) {
//       alert("No data to export");
//       return;
//     }

//     const doc = new jsPDF("l", "mm", "a4");
//     doc.setFontSize(14);
//     doc.text("Product Master Report", 14, 15);

//     const tableColumn = [
//       "S.No",
//       "Category",
//       "Subcategory",
//       "Code",
//       "Size",
//       "Qty"
//     ];

//     const tableRows = [];

//     let count = 1;
//     filteredProducts.forEach((p) => {
//       p.variants.forEach((v) => {
//         tableRows.push([
//           count++,
//           p.category,
//           p.subcategory,
//           v.code,
//           v.size,
//           v.qty
//         ]);
//       });
//     });

//     autoTable(doc, {
//       head: [tableColumn],
//       body: tableRows,
//       startY: 25,
//       styles: { fontSize: 9, cellPadding: 3 },
//       headStyles: { fillColor: [52, 73, 94] }
//     });


//     doc.save("products.pdf");
//   };

//   return (
//     <div className="pm-container">
//       <div className="pm-header">
//         <h2 className="pm-title"><FaBoxOpen className="icon-primary" /> Product Master</h2>
//         <button className="pm-add-btn" onClick={() => setShowModal(true)}><FaPlusCircle className="icon-accent" /> Add Product</button>
//       </div>

//       <div>
//         <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", marginBottom: "12px", gap: "12px" }}>
//           <input type="text" placeholder="Search by Category, Subcategory, Code or Size..." value={filterCode} onChange={handleSearchChange} style={{ flex: 1, padding: "6px 10px", borderRadius: "10px", border: "1px solid #000000", maxWidth: "600px",backgroundColor:'#fff' }} />
// {user?.email === "abhijit@spelux.in" && (
//   <button style={{ padding: "6px 12px", borderRadius: "5px", cursor: "pointer" }} onClick={handleShowBlockedData}>Blocked Data</button>
// )}
//           <button style={{ padding: "6px 12px", borderRadius: "5px", cursor: "pointer" }} onClick={handleExportPDF}>Export PDF</button>
//           <button style={{ padding: "6px 12px", borderRadius: "5px", cursor: "pointer" }} onClick={handleExportExcel}>Export Excel</button>
//         </div>
//         {filteredProducts.length === 0 ? (
//           <p style={{ fontStyle: "italic", color: "#555" }}>No products available.</p>
//         ) : (

//           <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
//             {paginated.map((v, index) => (
//               <div
//                 key={`${v.productId}-${v.id}`}
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   border: "1px solid #333",
//                   borderRadius: "8px",
//                   padding: "12px",
//                   backgroundColor: "#fff",
//                   boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
//                 }}
//               >
//                 <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginBottom: "8px" }}>
//                   <div><strong>S.No:</strong> {(page - 1) * perPage + index + 1}</div>
//                   <div><strong>Category:</strong> {v.category}</div>
//                   <div><strong>Subcategory:</strong> {v.subcategory}</div>
//                   <div><strong>Code:</strong> {v.code}</div>
//                 </div>

//                 <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginBottom: "8px" }}>
//                   <div><strong>Size:</strong> {v.size}</div>
//                   <div><strong>Qty:</strong> {v.qty}</div>
// <div>
//   <strong>Image:</strong>{" "}
//   {v.image ? (
//     <img
//       src={v.image}
//       alt="variant"
//       style={{ width: "50px", height: "50px", objectFit: "cover", cursor: "pointer", borderRadius: "4px" }}
//       onClick={() => setZoomImage(v.image)}
//     />
//   ) : (
//     "—"
//   )}
// </div>

//                 </div>

//                 <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
//                   <button
//                     onClick={() => handleEditProduct(products.find((p) => p.id === v.productId))}
//                     style={{
//                       backgroundColor: "#4CAF50",
//                       color: "#000",
//                       border: "none",
//                       padding: "6px 10px",
//                       borderRadius: "50px",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <Pencil size={12} />
//                   </button>

//                   <button
//                     disabled
//                     style={{
//                       backgroundColor: "#f44336",
//                       color: "#000",
//                       border: "none",
//                       padding: "6px 10px",
//                       borderRadius: "50px",
//                       cursor: "not-allowed",
//                     }}
//                   >
//                     <Trash size={12} />
//                   </button>

//                   <button
//                     onClick={() => handleShareWhatsApp(products.find((p) => p.id === v.productId), v)}
//                     style={{
//                       backgroundColor: "#25D366",
//                       color: "#000",
//                       border: "none",
//                       padding: "6px 10px",
//                       borderRadius: "50px",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <FaWhatsapp size={12} />
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>

//         )}
//         {totalPages > 1 && (
//           <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px", marginTop: "12px" }}>
//             <button disabled={page === 1} onClick={() => setPage(page - 1)} style={{ padding: "6px 10px", borderRadius: "4px", border: "1px solid #333", cursor: page === 1 ? "not-allowed" : "pointer", }}><FaChevronLeft /></button>
//             <span>Page {page} / {totalPages}</span>
//             <button disabled={page === totalPages} onClick={() => setPage(page + 1)} style={{ padding: "6px 10px", borderRadius: "4px", border: "1px solid #333", cursor: page === totalPages ? "not-allowed" : "pointer", }}><FaChevronRight /></button>
//           </div>
//         )}
//       </div>
// {zoomImage && (
//   <div onClick={() => setZoomImage(null)} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, cursor: "zoom-out", }}>
//     <img src={zoomImage} alt="Zoom" style={{ maxWidth: "90%", maxHeight: "90%", borderRadius: "6px", boxShadow: "0 0 20px #000", }} />
//   </div>
// )}

//       {showModal && (
//         <div
//           style={{
//             position: "fixed",
//             inset: 0,
//             backgroundColor: "rgba(0,0,0,0.45)",
//             display: "flex",
//             justifyContent: "center", alignItems: "center", zIndex: 1000, padding: "10px",
//           }}>
//           <div
//             style={{
//               background: "#fff",
//               width: "100%",
//               maxWidth: "480px", // smaller width for mobile-first
//               maxHeight: "90vh",
//               borderRadius: "14px",
//               overflow: "hidden",
//               boxShadow: "0 12px 30px rgba(0,0,0,0.3)",
//               display: "flex",
//               flexDirection: "column",
//             }}
//           >
//             {/* HEADER */}
//             <div
//               style={{
//                 padding: "14px 18px",
//                 borderBottom: "1px solid #eee",
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 background: "#f9fafb",
//               }}
//             >
//               <h3 style={{ margin: 0, fontSize: "16px", fontWeight: 600 }}>
//                 {editMode ? "Edit Product" : "Add Product"}
//               </h3>
//               <button
//                 onClick={resetForm}
//                 style={{
//                   background: "none",
//                   border: "none",
//                   fontSize: "18px",
//                   cursor: "pointer",
//                 }}
//               >
//                 <FaTimes />
//               </button>
//             </div>

//             {/* BODY */}
//             <form
//               onSubmit={handleSubmit}
//               style={{
//                 padding: "16px",
//                 overflowY: "auto",
//                 flex: 1,
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "16px",
//               }}
//             >
//               {/* CATEGORY */}
//               <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
//                 <label>Category</label>
//                 <select
//                   value={formData.category}
//                   onChange={(e) => {
//                     const selected = e.target.value;
//                     setFormData({ ...formData, category: selected });
//                     fetchSubcategories(selected);
//                   }}
//                   required
//                   style={{
//                     width: "100%",
//                     padding: "10px",
//                     borderRadius: "8px",
//                     border: "1px solid #ccc",
//                     fontSize: "14px",
//                   }}
//                 >
//                   <option value="">Select Category</option>
//                   {categories.map((c) => (
//                     <option key={c.id} value={c.name}>
//                       {c.name}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {/* SUBCATEGORY */}
//               <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
//                 <label>Subcategory</label>
//                 <select
//                   value={formData.subcategory}
//                   onChange={handleChange}
//                   name="subcategory"
//                   required
//                   style={{
//                     width: "100%",
//                     padding: "10px",
//                     borderRadius: "8px",
//                     border: "1px solid #ccc",
//                     fontSize: "14px",
//                   }}
//                 >
//                   <option value="">Select Subcategory</option>
//                   {subcategories.map((s) => (
//                     <option key={s.id} value={s.name}>
//                       {s.name}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {/* VARIANTS */}
//               <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
//                 {variants.map((v, i) => (
//                   <div
//                     key={i}
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       gap: "12px",
//                       padding: "10px",
//                       borderRadius: "8px",
//                       border: "1px solid #eee",
//                     }}
//                   >
//                     {/* Code */}
//                     <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
//                       <label>Code</label>
//                       <input
//                         type="text"
//                         name="code"
//                         value={v.code}
//                         onChange={(e) => handleVariantChange(i, e)}
//                         placeholder="Code"
//                         required
//                         style={{
//                           width: "100%",
//                           padding: "10px",
//                           borderRadius: "8px",
//                           border: "1px solid #ccc",
//                           fontSize: "14px",
//                         }}
//                       />
//                     </div>

//                     {/* Size */}
//                     <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
//                       <label>Size</label>
//                       <input
//                         type="text"
//                         name="size"
//                         value={v.size}
//                         onChange={(e) => handleVariantChange(i, e)}
//                         placeholder="Size"
//                         required
//                         style={{
//                           width: "100%",
//                           padding: "10px",
//                           borderRadius: "8px",
//                           border: "1px solid #ccc",
//                           fontSize: "14px",
//                         }}
//                       />
//                     </div>

//                     {/* Qty */}
//                     <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
//                       <label>Quantity</label>
//                       <input
//                         type="number"
//                         name="qty"
//                         value={v.qty}
//                         onChange={(e) => handleVariantChange(i, e)}
//                         placeholder="Qty"
//                         required
//                         style={{
//                           width: "100%",
//                           padding: "10px",
//                           borderRadius: "8px",
//                           border: "1px solid #ccc",
//                           fontSize: "14px",
//                         }}
//                       />
//                     </div>

//                     {/* Image */}
//                     <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
//                       <label>Image</label>
//                       <input
//                         type="file"
//                         name="image"
//                         onChange={(e) => handleVariantChange(i, e)}
//                         style={{ width: "100%" }}
//                       />
//                     </div>

//                     {/* Delete button if more than 1 variant */}
//                     {variants.length > 1 && (
//                       <button
//                         type="button"
//                         disabled
//                         style={{
//                           background: "none",
//                           border: "none",
//                           color: "#d32f2f",
//                           cursor: "not-allowed",
//                           alignSelf: "flex-end",
//                         }}
//                       >
//                         <FaTrash />
//                       </button>
//                     )}
//                   </div>
//                 ))}
//               </div>

//               {/* ADD VARIANT BUTTON */}
//               <button
//                 type="button"
//                 onClick={addVariant}
//                 style={{
//                   marginTop: "8px",
//                   background: "#1976d2",
//                   color: "#fff",
//                   padding: "10px 14px",
//                   borderRadius: "8px",
//                   border: "none",
//                   cursor: "pointer",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: "6px",
//                   fontSize: "14px",
//                   maxWidth: "160px",
//                 }}
//               >
//                 <FaPlusCircle /> Add Variant
//               </button>
//             </form>

//             {/* FOOTER */}
//             <div
//               style={{
//                 padding: "14px 18px",
//                 borderTop: "1px solid #eee",
//                 display: "flex",
//                 justifyContent: "flex-end",
//                 gap: "10px",
//                 background: "#fafafa",
//                 flexWrap: "wrap",
//               }}
//             >
//               <button
//                 type="submit"
//                 onClick={handleSubmit}
//                 style={{
//                   background: "#2e7d32",
//                   color: "#fff",
//                   padding: "10px 18px",
//                   borderRadius: "8px",
//                   border: "none",
//                   cursor: "pointer",
//                   fontWeight: 500,
//                 }}
//               >
//                 {editMode ? "Update" : "Save"}
//               </button>
//               <button
//                 type="button"
//                 onClick={resetForm}
//                 style={{
//                   background: "#e0e0e0",
//                   padding: "10px 18px",
//                   borderRadius: "8px",
//                   border: "none",
//                   cursor: "pointer",
//                 }}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//     </div >
//   );
// };

// export default ProductMaster;



// import React, { useState } from 'react';
// import { 
//   Plus, Search, Filter, Edit, Trash2, FileText, 
//   Download, MessageSquare, X, ChevronLeft, ChevronRight 
// } from 'lucide-react';

// // Sample dataset based on your custom product architecture
// const initialProducts = [
//   { id: 1, category: 'Teak', subcategory: 'Teak Classic', code: '2114', size: '2.44X1.22', qty: 88, image: null },
//   { id: 2, category: 'Smoked Series', subcategory: 'Smoked Oak', code: '8831', size: '2.44X1.22', qty: 42, image: null },
//   { id: 3, category: 'DYED Series', subcategory: 'Dyed Walnut', code: '4022', size: '3.05X1.22', qty: 15, image: null },
//   { id: 4, category: 'Excites', subcategory: 'Excites Premium', code: '1092', size: '2.44X1.22', qty: 110, image: null },
//   { id: 5, category: 'Tan Wood Series', subcategory: 'Tan Cedar', code: '5540', size: '3.05X1.22', qty: 64, image: null },
//   { id: 6, category: 'Specials - Herringbone', subcategory: 'Classic Herringbone', code: '7721', size: '2.44X1.22', qty: 23, image: null },
//   { id: 7, category: 'Standrad Naturals', subcategory: 'Natural Pine', code: '3011', size: '2.44X1.22', qty: 95, image: null },
//   { id: 8, category: 'Specials - Edgewood', subcategory: 'Edge Maple', code: '9942', size: '3.05X1.22', qty: 8, image: null },
//   { id: 9, category: 'Smoked Series', subcategory: 'Smoked Ash', code: '8835', size: '2.44X1.22', qty: 50, image: null },
//   { id: 10, category: 'Teak', subcategory: 'Teak Gold', code: '2119', size: '3.05X1.22', qty: 120, image: null },
//   { id: 11, category: 'DYED Series', subcategory: 'Dyed Maple', code: '4028', size: '2.44X1.22', qty: 33, image: null },
//   { id: 12, category: 'Specials - HDBX', subcategory: 'Box Finish Oak', code: '6610', size: '2.44X1.22', qty: 19, image: null }
// ];

// const CATEGORIES = [
//   "Excites", "ECHITED SERIES", "Specials - D-ART COLLECTIONS", 
//   "Specials - HDBX", "Specials - Herringbone", "Specials - Edgewood", 
//   "Smoked Series", "Tan Wood Series", "DYED Series", "Teak", "Standrad Naturals"
// ];
// const ProductMaster = () => {
//   const [products, setProducts] = useState(initialProducts);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   // Track active target element for updating configurations
//   const [editingProduct, setEditingProduct] = useState(null);

//   // Pagination States
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);

//   // Form State
//   const [category, setCategory] = useState('');
//   const [subcategory, setSubcategory] = useState('');
//   const [variants, setVariants] = useState([{ code: '', size: '', quantity: '', image: null }]);

//   // Add Variant Fields dynamically inside Form
//   const handleAddVariantRow = () => {
//     setVariants([...variants, { code: '', size: '', quantity: '', image: null }]);
//   };

//   const handleVariantChange = (index, field, value) => {
//     const updatedVariants = [...variants];
//     updatedVariants[index][field] = value;
//     setVariants(updatedVariants);
//   };

//   // Populate form with existing properties for mutation
//   const handleEditClick = (product) => {
//     setEditingProduct(product);
//     setCategory(product.category);
//     setSubcategory(product.subcategory);
//     setVariants([
//       { 
//         code: product.code, 
//         size: product.size, 
//         quantity: product.qty.toString(), 
//         image: product.image 
//       }
//     ]);
//     setIsModalOpen(true);
//   };

//   // Helper cleanup trigger on close
//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setEditingProduct(null);
//     setCategory('');
//     setSubcategory('');
//     setVariants([{ code: '', size: '', quantity: '', image: null }]);
//   };

//   // Submit Handler handles both standard additions and mutations
//   const handleSaveProduct = (e) => {
//     e.preventDefault();

//     if (editingProduct) {
//       // Edit Mode Mutation Path
//       const targetVariant = variants[0];
//       const updatedProducts = products.map((p) => {
//         if (p.id === editingProduct.id) {
//           return {
//             ...p,
//             category,
//             subcategory,
//             code: targetVariant.code,
//             size: targetVariant.size,
//             qty: parseInt(targetVariant.quantity) || 0,
//             image: targetVariant.image
//           };
//         }
//         return p;
//       });
//       setProducts(updatedProducts);
//     } else {
//       // Standard Insertion Batch addition pathing
//       const newEntries = variants.map((v, i) => ({
//         id: Date.now() + i,
//         category,
//         subcategory,
//         code: v.code,
//         size: v.size,
//         qty: parseInt(v.quantity) || 0,
//         image: v.image
//       }));
//       setProducts([...products, ...newEntries]);
//     }

//     handleCloseModal();
//   };

//   // WhatsApp Action Dispatcher
//   const handleWhatsAppShare = (product) => {
//     const text = `Product Detail: ${product.category} (${product.subcategory}) - Code: ${product.code} | Size: ${product.size} | Available Qty: ${product.qty}`;
//     window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`, '_blank');
//   };

//   // Filter Logic execution
//   const filteredProducts = products.filter(p => 
//     p.category.toLowerCase().includes(searchTerm.toLowerCase()) || 
//     p.subcategory.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     p.code.includes(searchTerm)
//   );

//   // Pagination Math Breakouts
//   const totalItems = filteredProducts.length;
//   const totalPages = Math.ceil(totalItems / itemsPerPage) || 1;

//   // Safe Fallback adjustment if filtering lowers matching size
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentProductsPageItems = filteredProducts.slice(indexOfFirstItem, indexOfLastItem);

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   // Detection setup for layout switching (simulating md responsiveness break without CSS rules)
//   const [isMobile, setIsMobile] = React.useState(typeof window !== 'undefined' ? window.innerWidth < 768 : false);

//   React.useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth < 768);
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   return (
//     <div style={{ padding: isMobile ? '16px' : '32px', display: 'flex', flexDirection: 'column', gap: isMobile ? '16px' : '24px', backgroundColor: '#f9fafb', minHeight: '100vh', color: '#111827', fontFamily: 'sans-serif' }}>

//       {/* Header Actions */}
//       <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'flex-start' : 'center', justifyContent: 'between', gap: '16px', borderBottom: '1px solid #e5e7eb', paddingBottom: '20px' }}>
//         <div style={{ flexGrow: 1 }}>
//           <h1 style={{ fontSize: '24px', fontWeight: '700', letterSpacing: '-0.025em', margin: 0 }}>Product Master</h1>
//           <p style={{ color: '#4b5563', fontSize: '14px', margin: '4px 0 0 0' }}>Manage configuration catalog parameters, layouts, and variants.</p>
//         </div>

//         <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px', width: isMobile ? '100%' : 'auto' }}>
//           <button style={{ flex: isMobile ? '1 1 0%' : 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', padding: '8px 12px', backgroundColor: '#f3f4f6', color: '#111827', border: '1px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', transition: 'all 0.2s' }}>
//             <FileText className="w-4 h-4" style={{ color: '#ef4444' }} /> Export PDF
//           </button>
//           <button style={{ flex: isMobile ? '1 1 0%' : 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', padding: '8px 12px', backgroundColor: '#f3f4f6', color: '#111827', border: '1px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', transition: 'all 0.2s' }}>
//             <Download className="w-4 h-4" style={{ color: '#16a34a' }} /> Export Excel
//           </button>
//           <button 
//             onClick={() => { setEditingProduct(null); setIsModalOpen(true); }}
//             style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 16px', backgroundColor: '#2563eb', color: '#ffffff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', width: isMobile ? '100%' : 'auto', justifyContent: 'center', transition: 'background-color 0.2s' }}
//           >
//             <Plus className="w-4 h-4" /> Add Product
//           </button>
//         </div>
//       </div>

//       {/* Analytics Counter Cards */}
//       <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, minmax(0, 1fr))' : 'repeat(3, minmax(0, 1fr))', gap: '16px' }}>
//         <div style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
//           <p style={{ color: '#6b7280', fontSize: isMobile ? '10px' : '12px', fontWeight: '500', uppercase: 'true', textTransform: 'uppercase', trackingWider: 'true', letterSpacing: '0.05em', margin: '0 0 4px 0' }}>Total Categories</p>
//           <h3 style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: '700', margin: 0 }}>{CATEGORIES.length}</h3>
//         </div>
//         <div style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
//           <p style={{ color: '#6b7280', fontSize: isMobile ? '10px' : '12px', fontWeight: '500', uppercase: 'true', textTransform: 'uppercase', trackingWider: 'true', letterSpacing: '0.05em', margin: '0 0 4px 0' }}>Total Stock</p>
//           <h3 style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: '700', color: '#16a34a', margin: 0 }}>
//             {products.reduce((acc, curr) => acc + curr.qty, 0)} Pcs
//           </h3>
//         </div>
//         <div style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)', gridColumn: isMobile ? 'span 2 / span 2' : 'auto' }}>
//           <p style={{ color: '#6b7280', fontSize: isMobile ? '10px' : '12px', fontWeight: '500', uppercase: 'true', textTransform: 'uppercase', trackingWider: 'true', letterSpacing: '0.05em', margin: '0 0 4px 0' }}>Blocked Profiles</p>
//           <h3 style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: '700', color: '#f97316', margin: 0 }}>0</h3>
//         </div>
//       </div>

//       {/* Filter Toolbar */}
//       <div style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px', display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '12px', alignItems: 'center' }}>
//         <div style={{ flexGrow: 1, width: '100%', position: 'relative' }}>
//           <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', width: '16px', height: '16px', color: '#6b7280' }} />
//           <input
//             type="text"
//             placeholder="Search here..."
//             value={searchTerm}
//             onChange={handleSearchChange}
//             style={{ width: '100%', paddingLeft: '36px', paddingRight: '16px', paddingTop: '8px', paddingBottom: '8px', backgroundColor: '#f3f4f6', borderRadius: '8px', border: '1px solid #e5e7eb', outline: 'none', fontSize: '14px', boxSizing: 'border-box' }}
//           />
//         </div>
//         <button style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 16px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', fontSize: '14px', borderRadius: '8px', cursor: 'pointer', width: isMobile ? '100%' : 'auto', justifyContent: 'center' }}>
//           <Filter className="w-4 h-4" /> Filter
//         </button>
//       </div>

//       {/* Presentation Container */}
//       <div style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>

//         {/* 1. MOBILE & SM CARD VIEW */}
//         {isMobile && (
//           <div style={{ display: 'flex', flexDirection: 'column' }}>
//             {currentProductsPageItems.length > 0 ? (
//               currentProductsPageItems.map((product, idx) => (
//                 <div key={product.id} style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '12px', borderBottom: idx !== currentProductsPageItems.length - 1 ? '1px solid #e5e7eb' : 'none' }}>
//                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//                     <div>
//                       <span style={{ fontSize: '12px', fontFamily: 'monospace', color: '#6b7280', marginRight: '8px' }}>#{indexOfFirstItem + idx + 1}</span>
//                       <span style={{ backgroundColor: '#f3f4f6', paddingLeft: '8px', paddingRight: '8px', paddingTop: '2px', paddingBottom: '2px', borderRadius: '4px', fontFamily: 'monospace', fontSize: '12px', fontWeight: '600' }}>{product.code}</span>
//                       <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#111827', marginTop: '4px', marginBottom: 0 }}>{product.category}</h4>
//                       <p style={{ fontSize: '12px', color: '#6b7280', margin: 0 }}>{product.subcategory}</p>
//                     </div>
//                     <div style={{ width: '48px', height: '48px', backgroundColor: '#f3f4f6', borderRadius: '4px', border: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', color: '#6b7280', overflow: 'hidden', flexShrink: 0 }}>
//                       {product.image ? <img src={product.image} alt="preview" style={{ objectFit: 'cover', width: '100%', height: '100%' }} /> : 'No Img'}
//                     </div>
//                   </div>

//                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '12px', borderTop: '1px dashed #e5e7eb', paddingTop: '8px' }}>
//                     <div>
//                       <span style={{ color: '#6b7280' }}>Size: </span>
//                       <span style={{ fontWeight: '500' }}>{product.size}</span>
//                     </div>
//                     <div>
//                       <span style={{ color: '#6b7280' }}>Qty: </span>
//                       <span style={{ fontWeight: '700', color: product.qty < 20 ? '#ef4444' : '#059669' }}>{product.qty}</span>
//                     </div>
//                   </div>

//                   {/* Mobile Action row */}
//                   <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', paddingTop: '4px' }}>
//                     <button 
//                       onClick={() => handleWhatsAppShare(product)}
//                       style={{ padding: '8px', backgroundColor: '#f0fdf4', border: 'none', borderRadius: '8px', color: '#16a34a', cursor: 'pointer' }}
//                     >
//                       <MessageSquare className="w-4 h-4" />
//                     </button>
//                     <button 
//                       onClick={() => handleEditClick(product)}
//                       style={{ padding: '8px', backgroundColor: '#f3f4f6', border: 'none', borderRadius: '8px', color: '#111827', cursor: 'pointer' }}
//                     >
//                       <Edit className="w-4 h-4" />
//                     </button>
//                     <button 
//                       onClick={() => setProducts(products.filter(p => p.id !== product.id))}
//                       style={{ padding: '8px', backgroundColor: '#fef2f2', border: 'none', borderRadius: '8px', color: '#ef4444', cursor: 'pointer' }}
//                     >
//                       <Trash2 className="w-4 h-4" />
//                     </button>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <div style={{ padding: '32px', textAlign: 'center', fontSize: '14px', color: '#6b7280' }}>No items match your filters.</div>
//             )}
//           </div>
//         )}

//         {/* 2. DESKTOP & TABLET LAYOUT */}
//         {!isMobile && (
//           <div style={{ overflowX: 'auto' }}>
//             <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse' }}>
//               <thead>
//                 <tr style={{ backgroundColor: 'rgba(243, 244, 246, 0.5)', borderBottom: '1px solid #e5e7eb', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#6b7280' }}>
//                   <th style={{ padding: '12px 16px', fontWeight: '600' }}>S.No</th>
//                   <th style={{ padding: '12px 16px', fontWeight: '600' }}>Category</th>
//                   <th style={{ padding: '12px 16px', fontWeight: '600' }}>Subcategory</th>
//                   <th style={{ padding: '12px 16px', fontWeight: '600' }}>Code</th>
//                   <th style={{ padding: '12px 16px', fontWeight: '600' }}>Size</th>
//                   <th style={{ padding: '12px 16px', fontWeight: '600' }}>Qty</th>
//                   <th style={{ padding: '12px 16px', fontWeight: '600' }}>Image</th>
//                   <th style={{ padding: '12px 16px', fontWeight: '600', textAlign: 'right' }}>Actions</th>
//                 </tr>
//               </thead>
//               <tbody style={{ fontSize: '14px' }}>
//                 {currentProductsPageItems.map((product, idx) => (
//                   <tr key={product.id} style={{ borderBottom: '1px solid #e5e7eb', transition: 'background-color 0.2s' }}>
//                     <td style={{ padding: '14px 16px', color: '#6b7280' }}>{indexOfFirstItem + idx + 1}</td>
//                     <td style={{ padding: '14px 16px', fontWeight: '600', color: '#111827' }}>{product.category}</td>
//                     <td style={{ padding: '14px 16px', color: '#6b7280' }}>{product.subcategory}</td>
//                     <td style={{ padding: '14px 16px' }}><span style={{ backgroundColor: '#f3f4f6', paddingLeft: '8px', paddingRight: '8px', paddingTop: '2px', paddingBottom: '2px', borderRadius: '4px', fontFamily: 'monospace', fontSize: '12px' }}>{product.code}</span></td>
//                     <td style={{ padding: '14px 16px', fontWeight: '500' }}>{product.size}</td>
//                     <td style={{ padding: '14px 16px' }}>
//                       <span style={{ fontWeight: '700', color: product.qty < 20 ? '#ef4444' : '#059669' }}>{product.qty}</span>
//                     </td>
//                     <td style={{ padding: '14px 16px' }}>
//                       <div style={{ width: '40px', height: '40px', backgroundColor: '#f3f4f6', borderRadius: '4px', border: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', color: '#6b7280', overflow: 'hidden' }}>
//                         {product.image ? <img src={product.image} alt="preview" style={{ objectFit: 'cover', width: '100%', height: '100%' }} /> : 'No Image'}
//                       </div>
//                     </td>
//                     <td style={{ padding: '14px 16px', textAlign: 'right' }}>
//                       <div style={{ display: 'flex', gap: '4px', justifyContent: 'flex-end' }}>
//                         <button onClick={() => handleWhatsAppShare(product)} style={{ padding: '8px', background: 'none', border: 'none', borderRadius: '8px', color: '#16a34a', cursor: 'pointer' }}><MessageSquare className="w-4 h-4" /></button>
//                         <button onClick={() => handleEditClick(product)} style={{ padding: '8px', background: 'none', border: 'none', borderRadius: '8px', color: '#6b7280', cursor: 'pointer' }}><Edit className="w-4 h-4" /></button>
//                         <button onClick={() => setProducts(products.filter(p => p.id !== product.id))} style={{ padding: '8px', background: 'none', border: 'none', borderRadius: '8px', color: '#ef4444', cursor: 'pointer' }}><Trash2 className="w-4 h-4" /></button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}

//         {/* Dynamic Pagination Footer */}
//         <div style={{ backgroundColor: 'rgba(243, 244, 246, 0.3)', borderTop: '1px solid #e5e7eb', padding: '12px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: isMobile ? 'column' : 'row', gap: '12px' }}>
//           <div style={{ fontSize: '12px', color: '#6b7280' }}>
//             Showing <span style={{ fontWeight: '600', color: '#111827' }}>{totalItems === 0 ? 0 : indexOfFirstItem + 1}</span> to{' '}
//             <span style={{ fontWeight: '600', color: '#111827' }}>{indexOfLastItem > totalItems ? totalItems : indexOfLastItem}</span> of{' '}
//             <span style={{ fontWeight: '600', color: '#111827' }}>{totalItems}</span> items
//           </div>

//           <div style={{ display: 'flex', alignItems: 'center', gap: '16px', justifyContent: 'space-between', width: isMobile ? '100%' : 'auto' }}>
//             <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
//               <span style={{ fontSize: '12px', color: '#6b7280' }}>Rows:</span>
//               <select
//                 value={itemsPerPage}
//                 onChange={(e) => { setItemsPerPage(parseInt(e.target.value)); setCurrentPage(1); }}
//                 style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '4px', paddingLeft: '6px', paddingRight: '6px', paddingTop: '4px', paddingBottom: '4px', fontSize: '12px', outline: 'none', color: '#111827' }}
//               >
//                 <option value={5}>5</option>
//                 <option value={10}>10</option>
//                 <option value={25}>25</option>
//               </select>
//             </div>

//             <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
//               <button
//                 onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//                 disabled={currentPage === 1}
//                 style={{ padding: '6px', border: '1px solid #e5e7eb', borderRadius: '6px', backgroundColor: '#ffffff', opacity: currentPage === 1 ? 0.4 : 1, cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
//               >
//                 <ChevronLeft className="w-4 h-4" />
//               </button>
//               <div style={{ fontSize: '12px', fontWeight: '500', paddingLeft: '8px', paddingRight: '8px', color: '#111827' }}>
//                 Page <span style={{ color: '#2563eb', fontWeight: '700' }}>{currentPage}</span> of {totalPages}
//               </div>
//               <button
//                 onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
//                 disabled={currentPage === totalPages}
//                 style={{ padding: '6px', border: '1px solid #e5e7eb', borderRadius: '6px', backgroundColor: '#ffffff', opacity: currentPage === totalPages ? 0.4 : 1, cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
//               >
//                 <ChevronRight className="w-4 h-4" />
//               </button>
//             </div>
//           </div>
//         </div>

//       </div>

//       {/* Add / Edit Product Modal */}
//       {isModalOpen && (
//         <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', zIndex: 50, overflowY: 'auto' }}>
//           <div style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', width: '100%', maxWidth: '672px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)', maxHeight: '90vh', overflowY: 'auto', position: 'relative' }}>

//             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px', borderBottom: '1px solid #e5e7eb', position: 'sticky', top: 0, backgroundColor: '#ffffff', zIndex: 10 }}>
//               <h2 style={{ fontSize: '18px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px', margin: 0 }}>
//                 <Plus className="w-5 h-5" style={{ color: '#2563eb' }} /> 
//                 {editingProduct ? 'Edit Product Parameters' : 'Add Product Batch'}
//               </h2>
//               <button onClick={handleCloseModal} style={{ padding: '4px', background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280' }}><X className="w-5 h-5" /></button>
//             </div>

//             <form onSubmit={handleSaveProduct} style={{ padding: isMobile ? '16px' : '24px', display: 'flex', flexDirection: 'column', gap: '24px' }}>

//               <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, minmax(0, 1fr))', gap: '16px' }}>
//                 <div>
//                   <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', color: '#6b7280', marginBottom: '4px' }}>Category *</label>
//                   <select 
//                     required 
//                     value={category} 
//                     onChange={(e) => setCategory(e.target.value)}
//                     style={{ width: '100%', padding: '10px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '14px', outline: 'none', color: '#111827', boxSizing: 'border-box' }}
//                   >
//                     <option value="">Select Category</option>
//                     {CATEGORIES.map((cat) => <option key={cat} value={cat}>{cat}</option>)}
//                   </select>
//                 </div>

//                 <div>
//                   <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', color: '#6b7280', marginBottom: '4px' }}>Subcategory *</label>
//                   <input 
//                     type="text" required placeholder="e.g. Teak Classic" 
//                     value={subcategory} onChange={(e) => setSubcategory(e.target.value)}
//                     style={{ width: '100%', padding: '10px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '14px', outline: 'none', color: '#111827', boxSizing: 'border-box' }}
//                   />
//                 </div>
//               </div>

//               <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: '16px' }}>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
//                   <h4 style={{ fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#6b7280', margin: 0 }}>Dimensions & Variants</h4>
//                   {!editingProduct && (
//                     <button type="button" onClick={handleAddVariantRow} style={{ fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px', color: '#2563eb', fontWeight: '600', background: 'none', border: 'none', cursor: 'pointer' }}>
//                       <Plus className="w-3 h-3" /> Add Variant
//                     </button>
//                   )}
//                 </div>

//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//                   {variants.map((variant, index) => (
//                     <div key={index} style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, minmax(0, 1fr))', gap: '12px', backgroundColor: 'rgba(243, 244, 246, 0.4)', padding: '12px', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
//                       <div>
//                         <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', marginBottom: '4px' }}>Code</label>
//                         <input 
//                           type="text" placeholder="2114" required value={variant.code} 
//                           onChange={(e) => handleVariantChange(index, 'code', e.target.value)}
//                           style={{ width: '100%', padding: '6px', backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '4px', fontSize: '12px', outline: 'none', boxSizing: 'border-box' }}
//                         />
//                       </div>
//                       <div>
//                         <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', marginBottom: '4px' }}>Size</label>
//                         <input 
//                           type="text" placeholder="2.44X1.22" required value={variant.size} 
//                           onChange={(e) => handleVariantChange(index, 'size', e.target.value)}
//                           style={{ width: '100%', padding: '6px', backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '4px', fontSize: '12px', outline: 'none', boxSizing: 'border-box' }}
//                         />
//                       </div>
//                       <div>
//                         <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', marginBottom: '4px' }}>Quantity</label>
//                         <input 
//                           type="number" placeholder="88" required value={variant.quantity} 
//                           onChange={(e) => handleVariantChange(index, 'quantity', e.target.value)}
//                           style={{ width: '100%', padding: '6px', backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '4px', fontSize: '12px', outline: 'none', boxSizing: 'border-box' }}
//                         />
//                       </div>
//                       <div>
//                         <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', marginBottom: '4px' }}>File Image</label>
//                         <input 
//                           type="file" accept="image/*"
//                           onChange={(e) => handleVariantChange(index, 'image', e.target.files[0] ? URL.createObjectURL(e.target.files[0]) : null)}
//                           style={{ width: '100%', fontSize: '10px', color: '#6b7280', cursor: 'pointer' }}
//                         />
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', borderTop: '1px solid #e5e7eb', paddingTop: '16px' }}>
//                 <button type="button" onClick={handleCloseModal} style={{ padding: '8px 16px', border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '14px', color: '#6b7280', backgroundColor: '#ffffff', cursor: 'pointer' }}>Cancel</button>
//                 <button type="submit" style={{ padding: '8px 16px', backgroundColor: '#2563eb', color: '#ffffff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' }}>
//                   {editingProduct ? 'Apply Updates' : 'Save Configuration'}
//                 </button>
//               </div>
//             </form>

//           </div>
//         </div>
//       )}

//     </div>
//   );
// }
// export default ProductMaster;


import axios from "axios";
import React, { useState, useEffect } from "react";
import { FaPlusCircle, FaTrash, FaBoxOpen, FaTimes, FaChevronLeft, FaChevronRight, FaWhatsapp } from "react-icons/fa";
import {
  Pencil,
  Trash,
  Download,
  FileText,
  Plus,
  Search,
  Filter,
  X,
  ChevronLeft,
  ChevronRight,
  MessageSquare,
  Edit,
  Trash2,
  ShieldX
} from 'lucide-react';
import './productMaster.css';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const API_BASE = "https://cloudapi.emedhatechnologies.com/pages/api/api";

const ProductMaster = () => {
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({ category: "", subcategory: "" });
  const [variants, setVariants] = useState([{ code: "", size: "", qty: "", image: null }]);
  const [products, setProducts] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [editProductId, setEditProductId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10); // Synchronized state identifier name
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);

  const [filterCode, setFilterCode] = useState("");
  const [zoomImage, setZoomImage] = useState(null);
  const [showBlockedOnly, setShowBlockedOnly] = useState(false);

  // View Engine Responsiveness Tracker
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const stored = sessionStorage.getItem("userData");
    if (stored) setUser(JSON.parse(stored));
  }, []);

  const userId = user
    ? user.type === "employee"
      ? user.parent_company_id
      : user.id
    : null;

  const currentUserId = user ? user.id : null;

  const fetchProducts = () => {
    if (!userId) return;
    fetch(`${API_BASE}/products/${userId}`)
      .then((res) => res.json())
      .then(setProducts)
      .catch((err) => console.error("Failed to fetch products:", err));
  };

  useEffect(() => {
    fetchProducts();
    fetchCategories();
  }, [userId]);

  const fetchCategories = async () => {
    if (!userId) return;
    try {
      const res = await axios.get(`${API_BASE}/categories?userId=${userId}`);
      setCategories(res.data);
    } catch (err) {
      console.error("Failed to fetch categories:", err);
    }
  };

  const fetchSubcategories = async (categoryName) => {
    if (!categoryName) {
      setSubcategories([]);
      return;
    }
    try {
      const res = await axios.get(
        `${API_BASE}/subcategories/by/name?categoryName=${encodeURIComponent(categoryName)}&userId=${userId}`
      );
      setSubcategories(res.data);
    } catch (err) {
      console.error("Failed to fetch subcategories:", err);
    }
  };

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleVariantFieldChange = (index, name, value) => {
    const updated = [...variants];
    updated[index][name] = value;
    setVariants(updated);
  };

  const handleVariantFileChange = (index, e) => {
    const updated = [...variants];
    updated[index].image = e.target.files ? e.target.files[0] : null;
    setVariants(updated);
  };

  const addVariantRow = () => setVariants([...variants, { code: "", size: "", qty: "", image: null }]);
  const removeVariantRow = (i) => setVariants(variants.filter((_, idx) => idx !== i));

  const resetForm = () => {
    setFormData({ category: "", subcategory: "" });
    setVariants([{ code: "", size: "", qty: "", image: null }]);
    setEditMode(false);
    setEditProductId(null);
    setShowModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userId) return alert("Please log in");

    try {
      let productId = editProductId;

      if (!editMode) {
        const productRes = await fetch(`${API_BASE}/products`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ...formData, user_id: userId, current_user_id: currentUserId }),
        });
        const data = await productRes.json();
        productId = data.product_id;
      } else {
        await fetch(`${API_BASE}/products/${productId}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ...formData, current_user_id: currentUserId }),
        });
      }

      for (const variant of variants) {
        const form = new FormData();
        form.append("code", variant.code);
        form.append("size", variant.size);
        form.append("qty", variant.qty);
        form.append("current_user_id", currentUserId);
        if (variant.image) form.append("image", variant.image);

        if (variant.id) {
          await fetch(`${API_BASE}/variants/${variant.id}`, {
            method: "PUT",
            body: form,
          });
        } else {
          await fetch(`${API_BASE}/products/${productId}/variants`, {
            method: "POST",
            body: form,
          });
        }
      }

      alert(editMode ? "✅ Product updated!" : "✅ Product added!");
      resetForm();
      fetchProducts();
    } catch (err) {
      console.error(err);
      alert("❌ Error saving product");
    }
  };

  const handleEditProduct = async (product) => {
    setEditMode(true);
    setEditProductId(product.id);
    setFormData({ category: product.category, subcategory: "" });
    await fetchSubcategories(product.category);
    setFormData({ category: product.category, subcategory: product.subcategory });
    setVariants(
      product.variants.map((v) => ({
        id: v.id,
        code: v.code || "",
        size: v.size || "",
        qty: v.qty || "",
        image: null,
      }))
    );
    setShowModal(true);
  };

  const handleDeleteProduct = async (id) => {
    if (!window.confirm("Are you sure you want to delete this product structure?")) return;
    try {
      await fetch(`${API_BASE}/products/${id}`, { method: "DELETE" });
      fetchProducts();
    } catch (err) {
      console.error(err);
    }
  };

  const handleCategorySelectChange = async (e) => {
    const val = e.target.value;
    setFormData({ ...formData, category: val, subcategory: "" });
    await fetchSubcategories(val);
  };

  const handleSearchChange = (e) => {
    setFilterCode(e.target.value);
    setShowBlockedOnly(false);
  };

  // const handleShowBlockedData = () => {
  //   setShowBlockedOnly(true);
  //   setPage(1);
  // };
  const handleShowBlockedData = () => {
    setShowBlockedOnly(prev => {
      const next = !prev;
      if (next) setPage(1);
      return next;
    });
  };
  // Processing Filter Chains
  const filteredProducts = products
    .map((product) => {
      let variantsToShow = product.variants || [];

      if (showBlockedOnly && user?.email === "abhijit@spelux.in") {
        variantsToShow = variantsToShow.filter((v) =>
          v.code?.toLowerCase().includes("blk")
        );
      } else if (filterCode) {
        const search = filterCode.toLowerCase();
        variantsToShow = variantsToShow.filter((v) =>
          product.category?.toLowerCase().includes(search) ||
          product.subcategory?.toLowerCase().includes(search) ||
          v.code?.toLowerCase().includes(search) ||
          v.size?.toLowerCase().includes(search)
        );
      }

      if (variantsToShow.length === 0) return null;
      return { ...product, variants: variantsToShow };
    })
    .filter(Boolean);

  const flattenedVariants = filteredProducts
    .map((p) =>
      (p.variants || []).map((v) => ({
        ...v,
        category: p.category,
        subcategory: p.subcategory,
        productId: p.id,
        rawProduct: p
      }))
    )
    .flat();

  const totalItems = flattenedVariants.length;
  const totalPages = Math.ceil(totalItems / perPage) || 1;
  const indexOfFirstItem = (page - 1) * perPage;
  const indexOfLastItem = page * perPage;
  const paginated = flattenedVariants.slice(indexOfFirstItem, indexOfLastItem);

  const totalStockCount = products.reduce((acc, curr) => {
    const variantSum = (curr.variants || []).reduce((sub, v) => sub + (Number(v.qty) || 0), 0);
    return acc + variantSum;
  }, 0);

  const handleExportExcel = () => {
    if (!filteredProducts || filteredProducts.length === 0) return alert("No data to export");
    const headers = ["S.No", "Category", "Subcategory", "Code", "Size", "Qty", "Image"];
    const rows = filteredProducts
      .map((p, pIndex) =>
        (p.variants || []).map((v, vIndex) => [
          pIndex * perPage + vIndex + 1,
          p.category,
          p.subcategory,
          v.code,
          v.size,
          v.qty,
          v.image || ""
        ])
      )
      .flat();

    const csvContent = [headers.join(","), ...rows.map(r => r.join(","))].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "products.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleShareWhatsApp = async (variant) => {
    if (!variant) return;
    const email = user?.email;

    try {
      await fetch("https://cloudapi.emedhatechnologies.com/pages/api/api/share-log", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email,
          variant_id: variant.id,
          variant_code: variant.code,
        }),
      });
    } catch (error) {
      console.error("Share log failed", error);
    }

    const text = `Category: ${variant.category}\nSubcategory: ${variant.subcategory}\nCode: ${variant.code}\nSize: ${variant.size}\nQty: ${variant.qty}\nImage: ${variant.image || "—"}`;
    const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");
  };

  const handleExportPDF = () => {
    if (!filteredProducts || filteredProducts.length === 0) {
      alert("No data to export");
      return;
    }

    const doc = new jsPDF("l", "mm", "a4");
    doc.setFontSize(14);
    doc.text("Product Master Report", 14, 15);

    const tableColumn = ["S.No", "Category", "Subcategory", "Code", "Size", "Qty"];
    const tableRows = [];

    let count = 1;
    filteredProducts.forEach((p) => {
      (p.variants || []).forEach((v) => {
        tableRows.push([count++, p.category, p.subcategory, v.code, v.size, v.qty]);
      });
    });

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 25,
      styles: { fontSize: 9, cellPadding: 3 },
      headStyles: { fillColor: [52, 73, 94] }
    });

    doc.save("products.pdf");
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: isMobile ? '16px' : '24px', backgroundColor: '#f9fafb', minHeight: '100vh', color: '#111827', fontFamily: 'sans-serif' }}>

      {/* Header Actions */}
      <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'flex-start' : 'center', justifyContent: 'space-between', gap: '16px', borderBottom: '1px solid #e5e7eb', paddingBottom: '20px' }}>
        <div style={{ flexGrow: 1 }}>
          <h1 style={{ fontSize: '24px', fontWeight: '700', letterSpacing: '-0.025em', margin: 0 }}>Product Master</h1>
          <p style={{ color: '#4b5563', fontSize: '14px', margin: '4px 0 0 0' }}>Manage configuration catalog parameters, layouts, and variants.</p>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px', width: isMobile ? '100%' : 'auto' }}>
          {user?.email === "abhijit@spelux.in" && (
            <button
              style={{ flex: isMobile ? '1 1 0%' : 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', padding: '8px 12px', backgroundColor: '#f3f4f6', color: '#111827', border: '1px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', transition: 'all 0.2s' }}
              //style={{ padding: "6px 12px", borderRadius: "5px", cursor: "pointer" }} 
              onClick={handleShowBlockedData}>
              <ShieldX className="w-4 h-4" style={{ color: '#1d1d1d', width: '16px', height: '16px' }} />    Blocked Data
            </button>
          )}
          <button onClick={handleExportPDF} style={{ flex: isMobile ? '1 1 0%' : 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', padding: '8px 12px', backgroundColor: '#f3f4f6', color: '#111827', border: '1px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', transition: 'all 0.2s' }}>
            <FileText className="w-4 h-4" style={{ color: '#ef4444', width: '16px', height: '16px' }} /> Export PDF
          </button>
          <button onClick={handleExportExcel} style={{ flex: isMobile ? '1 1 0%' : 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', padding: '8px 12px', backgroundColor: '#f3f4f6', color: '#111827', border: '1px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', transition: 'all 0.2s' }}>
            <Download className="w-4 h-4" style={{ color: '#16a34a', width: '16px', height: '16px' }} /> Export Excel
          </button>
          <button
            onClick={() => { resetForm(); setShowModal(true); }}
            style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 16px', backgroundColor: '#2563eb', color: '#ffffff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', width: isMobile ? '100%' : 'auto', justifyContent: 'center', transition: 'background-color 0.2s' }}
          >
            <Plus className="w-4 h-4" style={{ width: '16px', height: '16px' }} /> Add Product
          </button>
        </div>
      </div>

      {/* Analytics Counter Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2, minmax(0, 1fr))' : 'repeat(3, minmax(0, 1fr))', gap: '16px' }}>
        <div style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
          <p style={{ color: '#6b7280', fontSize: isMobile ? '10px' : '12px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.05em', margin: '0 0 4px 0' }}>Total Categories</p>
          <h3 style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: '700', margin: 0 }}>{categories.length}</h3>
        </div>
        <div style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
          <p style={{ color: '#6b7280', fontSize: isMobile ? '10px' : '12px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.05em', margin: '0 0 4px 0' }}>Total Stock</p>
          <h3 style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: '700', color: '#16a34a', margin: 0 }}>
            {totalStockCount} Pcs
          </h3>
        </div>
        {/* <div onClick={handleShowBlockedData} style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)', gridColumn: isMobile ? 'span 2 / span 2' : 'auto', cursor: 'pointer' }}>
          <p style={{ color: '#6b7280', fontSize: isMobile ? '10px' : '12px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.05em', margin: '0 0 4px 0' }}>Blocked Profiles</p>
          <h3 style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: '700', color: '#f97316', margin: 0 }}>
            {user?.email === "abhijit@spelux.in" ? "View BLK" : "0"}
          </h3>
        </div> */}
        {user?.email === "abhijit@spelux.in" && (
          <div
            onClick={handleShowBlockedData}
            style={{
              backgroundColor: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: '12px',
              padding: '16px',
              boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
              gridColumn: isMobile ? 'span 2 / span 2' : 'auto',
              cursor: 'pointer'
            }}
          >
            <p
              style={{
                color: '#6b7280',
                fontSize: isMobile ? '10px' : '12px',
                fontWeight: '500',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                margin: '0 0 4px 0'
              }}
            >
              Blocked Profiles
            </p>

            <h3
              style={{
                fontSize: isMobile ? '20px' : '24px',
                fontWeight: '700',
                color: showBlockedOnly ? '#ef4444' : '#f97316',
                margin: 0
              }}
            >
              {showBlockedOnly ? "Hide Blocked" : "Show Blocked"}
            </h3>
          </div>
        )}

      </div>

      {/* Filter Toolbar */}
      <div style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px', display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '12px', alignItems: 'center' }}>
        <div style={{ flexGrow: 1, width: '100%', position: 'relative' }}>
          <Search className="w-4 h-4 text-muted-foreground" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', width: '16px', height: '16px', color: '#6b7280' }} />
          <input
            type="text"
            placeholder="Search here..."
            value={filterCode}
            onChange={handleSearchChange}
            style={{ width: '100%', paddingLeft: '36px', paddingRight: '16px', paddingTop: '8px', paddingBottom: '8px', backgroundColor: '#f3f4f6', borderRadius: '8px', border: '1px solid #e5e7eb', outline: 'none', fontSize: '14px', boxSizing: 'border-box' }}
          />
        </div>
        <button style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 16px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', fontSize: '14px', borderRadius: '8px', cursor: 'pointer', width: isMobile ? '100%' : 'auto', justifyContent: 'center' }}>
          <Filter className="w-4 h-4" style={{ width: '16px', height: '16px' }} /> Filter
        </button>
      </div>

      {/* Presentation Container */}
      <div style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>

        {/* 1. MOBILE RESPONSIVE CARD ENGINE */}
        {isMobile && (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {paginated.length > 0 ? (
              paginated.map((item, idx) => (
                <div key={item.id || idx} style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '12px', borderBottom: idx !== paginated.length - 1 ? '1px solid #e5e7eb' : 'none' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                      <span style={{ fontSize: '12px', fontFamily: 'monospace', color: '#6b7280', marginRight: '8px' }}>#{indexOfFirstItem + idx + 1}</span>
                      <span style={{ backgroundColor: '#f3f4f6', paddingLeft: '8px', paddingRight: '8px', paddingTop: '2px', paddingBottom: '2px', borderRadius: '4px', fontFamily: 'monospace', fontSize: '12px', fontWeight: '600' }}>{item.code}</span>
                      <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#111827', marginTop: '4px', marginBottom: 0 }}>{item.category}</h4>
                      <p style={{ fontSize: '12px', color: '#6b7280', margin: 0 }}>{item.subcategory}</p>
                    </div>
                    <div style={{ width: '48px', height: '48px', backgroundColor: '#f3f4f6', borderRadius: '4px', border: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', color: '#6b7280', overflow: 'hidden', flexShrink: 0 }}>
                      {item.image ? <img src={item.image} alt="preview" style={{ objectFit: 'cover', width: '100%', height: '100%' }} /> : 'No Img'}
                    </div>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '12px', borderTop: '1px dashed #e5e7eb', paddingTop: '8px' }}>
                    <div>
                      <span style={{ color: '#6b7280' }}>Size: </span>
                      <span style={{ fontWeight: '500' }}>{item.size}</span>
                    </div>
                    <div>
                      <span style={{ color: '#6b7280' }}>Qty: </span>
                      <span style={{ fontWeight: '700', color: item.qty < 20 ? '#ef4444' : '#059669' }}>{item.qty}</span>
                    </div>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', paddingTop: '4px' }}>
                    <button onClick={() => handleShareWhatsApp(item)} style={{ padding: '8px', backgroundColor: '#f0fdf4', border: 'none', borderRadius: '8px', color: '#16a34a', cursor: 'pointer' }}>
                      <MessageSquare className="w-4 h-4" style={{ width: '16px', height: '16px' }} />
                    </button>
                    <button onClick={() => handleEditProduct(item.rawProduct)} style={{ padding: '8px', backgroundColor: '#f3f4f6', border: 'none', borderRadius: '8px', color: '#111827', cursor: 'pointer' }}>
                      <Edit className="w-4 h-4" style={{ width: '16px', height: '16px' }} />
                    </button>
                    <button onClick={() => handleDeleteProduct(item.productId)} style={{ padding: '8px', backgroundColor: '#fef2f2', border: 'none', borderRadius: '8px', color: '#ef4444', cursor: 'pointer' }}>
                      <Trash2 className="w-4 h-4" style={{ width: '16px', height: '16px' }} />
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div style={{ padding: '32px', textAlign: 'center', fontSize: '14px', color: '#6b7280' }}>No items match your filters.</div>
            )}
          </div>
        )}

        {/* 2. DESKTOP GRID & DATA TABLE */}
        {!isMobile && (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: 'rgba(243, 244, 246, 0.5)', borderBottom: '1px solid #e5e7eb', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#6b7280' }}>
                  <th style={{ padding: '12px 16px', fontWeight: '600' }}>S.No</th>
                  <th style={{ padding: '12px 16px', fontWeight: '600' }}>Category</th>
                  <th style={{ padding: '12px 16px', fontWeight: '600' }}>Subcategory</th>
                  <th style={{ padding: '12px 16px', fontWeight: '600' }}>Code</th>
                  <th style={{ padding: '12px 16px', fontWeight: '600' }}>Size</th>
                  <th style={{ padding: '12px 16px', fontWeight: '600' }}>Qty</th>
                  <th style={{ padding: '12px 16px', fontWeight: '600' }}>Image</th>
                  <th style={{ padding: '12px 16px', fontWeight: '600', textAlign: 'right' }}>Actions</th>
                </tr>
              </thead>
              <tbody style={{ fontSize: '14px' }}>
                {paginated.map((item, idx) => (
                  <tr key={item.id || idx} style={{ borderBottom: '1px solid #e5e7eb', transition: 'background-color 0.2s' }}>
                    <td style={{ padding: '14px 16px', color: '#6b7280' }}>{indexOfFirstItem + idx + 1}</td>
                    <td style={{ padding: '14px 16px', fontWeight: '600', color: '#111827' }}>{item.category}</td>
                    <td style={{ padding: '14px 16px', color: '#6b7280' }}>{item.subcategory}</td>
                    <td style={{ padding: '14px 16px' }}><span style={{ backgroundColor: '#f3f4f6', paddingLeft: '8px', paddingRight: '8px', paddingTop: '2px', paddingBottom: '2px', borderRadius: '4px', fontFamily: 'monospace', fontSize: '12px' }}>{item.code}</span></td>
                    <td style={{ padding: '14px 16px', fontWeight: '500' }}>{item.size}</td>
                    <td style={{ padding: '14px 16px' }}>
                      <span style={{ fontWeight: '700', color: item.qty < 20 ? '#ef4444' : '#059669' }}>{item.qty}</span>
                    </td>
                    <td style={{ padding: '14px 16px' }}>
                      {/* <div style={{ width: '40px', height: '40px', backgroundColor: '#f3f4f6', borderRadius: '4px', border: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', color: '#6b7280', overflow: 'hidden' }}>
                        {item.image ? <img src={item.image} alt="preview" style={{ objectFit: 'cover', width: '100%', height: '100%' }} /> : 'No Image'}
                      </div> */}
                      <div>
                        <strong>Image:</strong>{" "}
                        {item.image ? (
                          <img
                            src={item.image}
                            alt="variant"
                            style={{ width: "50px", height: "50px", objectFit: "cover", cursor: "pointer", borderRadius: "4px" }}
                            onClick={() => setZoomImage(item.image)}
                          />
                        ) : (
                          "—"
                        )}
                      </div>

                    </td>
                    <td style={{ padding: '14px 16px', textAlign: 'right' }}>
                      <div style={{ display: 'flex', gap: '4px', justifyContent: 'flex-end' }}>
                        <button onClick={() => handleShareWhatsApp(item)} style={{ padding: '8px', background: 'none', border: 'none', borderRadius: '8px', color: '#16a34a', cursor: 'pointer' }}><MessageSquare className="w-4 h-4" style={{ width: '16px', height: '16px' }} /></button>
                        <button onClick={() => handleEditProduct(item.rawProduct)} style={{ padding: '8px', background: 'none', border: 'none', borderRadius: '8px', color: '#6b7280', cursor: 'pointer' }}><Edit className="w-4 h-4" style={{ width: '16px', height: '16px' }} /></button>
                        <button onClick={() => handleDeleteProduct(item.productId)} style={{ padding: '8px', background: 'none', border: 'none', borderRadius: '8px', color: '#ef4444', cursor: 'pointer' }}><Trash2 className="w-4 h-4" style={{ width: '16px', height: '16px' }} /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Dynamic Pagination Footer */}
        <div style={{ backgroundColor: 'rgba(243, 244, 246, 0.3)', borderTop: '1px solid #e5e7eb', padding: '12px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: isMobile ? 'column' : 'row', gap: '12px' }}>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            Showing <span style={{ fontWeight: '600', color: '#111827' }}>{totalItems === 0 ? 0 : indexOfFirstItem + 1}</span> to{' '}
            <span style={{ fontWeight: '600', color: '#111827' }}>{indexOfLastItem > totalItems ? totalItems : indexOfLastItem}</span> of{' '}
            <span style={{ fontWeight: '600', color: '#111827' }}>{totalItems}</span> items
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', justifyContent: 'space-between', width: isMobile ? '100%' : 'auto' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{ fontSize: '12px', color: '#6b7280' }}>Rows:</span>
              <select
                value={perPage}
                onChange={(e) => { setPerPage(parseInt(e.target.value)); setPage(1); }}
                style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '4px', paddingLeft: '6px', paddingRight: '6px', paddingTop: '4px', paddingBottom: '4px', fontSize: '12px', outline: 'none', color: '#111827' }}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={40}>40</option>
              </select>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <button
                onClick={() => setPage(prev => Math.max(prev - 1, 1))}
                disabled={page === 1}
                style={{ padding: '6px', border: '1px solid #e5e7eb', borderRadius: '6px', backgroundColor: '#ffffff', opacity: page === 1 ? 0.4 : 1, cursor: page === 1 ? 'not-allowed' : 'pointer' }}
              >
                <ChevronLeft className="w-4 h-4" style={{ width: '16px', height: '16px' }} />
              </button>
              <div style={{ fontSize: '12px', fontWeight: '500', paddingLeft: '8px', paddingRight: '8px', color: '#111827' }}>
                Page <span style={{ color: '#2563eb', fontWeight: '700' }}>{page}</span> of {totalPages}
              </div>
              <button
                onClick={() => setPage(prev => Math.min(prev + 1, totalPages))}
                disabled={page === totalPages}
                style={{ padding: '6px', border: '1px solid #e5e7eb', borderRadius: '6px', backgroundColor: '#ffffff', opacity: page === totalPages ? 0.4 : 1, cursor: page === totalPages ? 'not-allowed' : 'pointer' }}
              >
                <ChevronRight className="w-4 h-4" style={{ width: '16px', height: '16px' }} />
              </button>
            </div>
          </div>
        </div>

      </div>

      {zoomImage && (
        <div onClick={() => setZoomImage(null)} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, cursor: "zoom-out", }}>
          <img src={zoomImage} alt="Zoom" style={{ maxWidth: "90%", maxHeight: "90%", borderRadius: "6px", boxShadow: "0 0 20px #000", }} />
        </div>
      )}

      {/* Configuration Mutation/Insertion Form Overlay */}
      {showModal && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', zIndex: 50, overflowY: 'auto' }}>
          <div style={{ backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '12px', width: '100%', maxWidth: '672px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)', maxHeight: '90vh', overflowY: 'auto', position: 'relative' }}>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px', borderBottom: '1px solid #e5e7eb', position: 'sticky', top: 0, backgroundColor: '#ffffff', zIndex: 10 }}>
              <h2 style={{ fontSize: '18px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px', margin: 0 }}>
                <Plus className="w-5 h-5" style={{ color: '#2563eb' }} />
                {editMode ? 'Edit Product Parameters' : 'Add Product Batch'}
              </h2>
              <button onClick={resetForm} style={{ padding: '4px', background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280' }}><X className="w-5 h-5" /></button>
            </div>

            <form onSubmit={handleSubmit} style={{ padding: isMobile ? '16px' : '24px', display: 'flex', flexDirection: 'column', gap: '24px' }}>

              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, minmax(0, 1fr))', gap: '16px' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', color: '#6b7280', marginBottom: '4px' }}>Category *</label>
                  <select
                    required
                    name="category"
                    value={formData.category}
                    onChange={handleCategorySelectChange}
                    style={{ width: '100%', padding: '10px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '14px', outline: 'none', color: '#111827', boxSizing: 'border-box' }}
                  >
                    <option value="">Select Category</option>
                    {categories.map((cat) => (
                      <option key={cat.id || cat.name || cat} value={cat.name || cat}>
                        {cat.name || cat}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', color: '#6b7280', marginBottom: '4px' }}>Subcategory *</label>
                  <select
                    required
                    name="subcategory"
                    value={formData.subcategory}
                    onChange={handleChange}
                    style={{ width: '100%', padding: '10px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '14px', outline: 'none', color: '#111827', boxSizing: 'border-box' }}
                  >
                    <option value="">Select Subcategory</option>
                    {subcategories.map((sub) => (
                      <option key={sub.id || sub.name || sub} value={sub.name || sub}>
                        {sub.name || sub}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: '16px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                  <h4 style={{ fontSize: '12px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#6b7280', margin: 0 }}>Dimensions & Variants</h4>
                  {!editMode && (
                    <button type="button" onClick={addVariantRow} style={{ fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px', color: '#2563eb', fontWeight: '600', background: 'none', border: 'none', cursor: 'pointer' }}>
                      <Plus className="w-3 h-3" /> Add Variant
                    </button>
                  )}
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  {variants.map((variant, index) => (
                    <div key={index} style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, minmax(0, 1fr))', gap: '12px', backgroundColor: 'rgba(243, 244, 246, 0.4)', padding: '12px', borderRadius: '8px', border: '1px solid #e5e7eb', position: 'relative' }}>
                      <div>
                        <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', marginBottom: '4px' }}>Code</label>
                        <input
                          type="text" placeholder="2114" required value={variant.code}
                          onChange={(e) => handleVariantFieldChange(index, 'code', e.target.value)}
                          style={{ width: '100%', padding: '6px', backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '4px', fontSize: '12px', outline: 'none', boxSizing: 'border-box' }}
                        />
                      </div>
                      <div>
                        <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', marginBottom: '4px' }}>Size</label>
                        <input
                          type="text" placeholder="12x12" required value={variant.size}
                          onChange={(e) => handleVariantFieldChange(index, 'size', e.target.value)}
                          style={{ width: '100%', padding: '6px', backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '4px', fontSize: '12px', outline: 'none', boxSizing: 'border-box' }}
                        />
                      </div>
                      <div>
                        <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', marginBottom: '4px' }}>Qty</label>
                        <input
                          type="number" placeholder="100" required value={variant.qty}
                          onChange={(e) => handleVariantFieldChange(index, 'qty', e.target.value)}
                          style={{ width: '100%', padding: '6px', backgroundColor: '#ffffff', border: '1px solid #e5e7eb', borderRadius: '4px', fontSize: '12px', outline: 'none', boxSizing: 'border-box' }}
                        />
                      </div>
                      <div>
                        <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', marginBottom: '4px' }}>Image File</label>
                        <input
                          type="file" accept="image/*"
                          onChange={(e) => handleVariantFileChange(index, e)}
                          style={{ width: '100%', fontSize: '11px' }}
                        />
                      </div>
                      {variants.length > 1 && !editMode && (
                        <button type="button" onClick={() => removeVariantRow(index)} style={{ position: 'absolute', top: '4px', right: '4px', background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '12px' }}>
                          <X style={{ width: '14px', height: '14px' }} />
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', borderTop: '1px solid #e5e7eb', paddingTop: '16px' }}>
                <button type="button" onClick={resetForm} style={{ padding: '8px 16px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '14px', cursor: 'pointer' }}>
                  Cancel
                </button>
                <button type="submit" style={{ padding: '8px 16px', backgroundColor: '#2563eb', color: '#ffffff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' }}>
                  {editMode ? 'Save System Changes' : 'Publish Product Configuration'}
                </button>
              </div>

            </form>
          </div>
        </div>
      )}

    </div>
  );
};

export default ProductMaster;